import { useStringForPlaceholders } from "@1js/localization-components";
import { Tag } from "@fluentui/react-components";
import React from "react";
import type { ExtensionPrompt } from "../data";
import { PromptAuthorLabel } from "./PromptAuthor.strings";
import { useStyles } from "./PromptAuthor.styles";

export type ExtensionAuthorProps = {
  prompt: ExtensionPrompt;
};

export const ExtensionAuthor: React.FC<ExtensionAuthorProps> = React.memo(
  ({ prompt }) => {
    const styles = useStyles()();
    const authorLabel = useStringForPlaceholders(PromptAuthorLabel);
    const displayName = prompt.DeveloperName ?? "";

    if (!displayName) {
      return null;
    }

    return (
      <Tag size="small" data-testid="extension-author-tag">
        <span aria-hidden={true}>{displayName}</span>
        <span className={styles.srOnly}>
          {authorLabel({ authorName: displayName })}
        </span>
      </Tag>
    );
  }
);

ExtensionAuthor.displayName = "ExtensionAuthor";
